import { render, staticRenderFns } from "./_salary.vue?vue&type=template&id=4f9b456e&"
import script from "./_salary.vue?vue&type=script&lang=js&"
export * from "./_salary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports